export const DATA_ISSUES = 'dataIssues';
